<div class="filter-group-inline-container">
    <div class="filter-label-inline">
        <label for="selectedFormAssessorFilter">Using Factors</label>
    </div>
    <div class="filter-control-inline">
        <select
            name="selectedAssessorFilter"
            class="form-select form-select-sm"
            [disabled]="!assessorFilters.length"
            [(ngModel)]="selectedAssessorFilter"
            (change)="onSelectedAssessorFilterChange()">
            @for (assessorFilter of assessorFilters; track assessorFilter) {
                <option [ngValue]="assessorFilter">{{ assessorFilter.assessorName }}</option>
            }
        </select>
    </div>
</div>
